import { useQuery } from "react-query";
import { getCoursePayments } from "../services/finance/coursePayments";
import { PagedRequestType } from "../types/PagedResults";
import { Key_coursePayments } from "../utils/constants";

export const useGetCoursePaymentsQuery = (data: PagedRequestType, options: any = null) =>
  useQuery(
    [Key_coursePayments, JSON.stringify(data)],
    () => getCoursePayments(data),
    options ? { ...options } : {}
  );
